var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBos2Top(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 32,
    viewBox: "0 0 1439 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 170.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 201.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 232.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 263.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 294.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 325.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 356.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 387.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 418.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 449.508,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 480.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 511.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 542.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 573.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 604.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 635.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 666.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 697.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 728.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 759.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 790.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 821.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 852.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 883.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 914.525,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 465.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 496.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 527.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 558.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 589.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 620.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 651.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 682.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 713.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 744.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 775.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 806.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 837.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 868.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 899.017,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 945.542,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 976.542,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1007.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1038.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1069.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 1100.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 1131.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 1162.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 1193.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 1224.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1255.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 1286.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 1317.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 1348.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 1379.54,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 930.034,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 961.034,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 992.034,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 1054.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 1085.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 1147.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 1178.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 1240.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 1271.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 1333.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 1364.03,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 1410.56,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.05,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 1426.05,
    y: 15.5078,
    width: 15.5092,
    height: 15.5092,
    fill: "#8D78F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBos2Top);
export default __webpack_public_path__ + "static/media/bos2top.d4aef6a56c1bbfdcf4e951d7fd1d4b5f.svg";
export { ForwardRef as ReactComponent };